"use client";

import React, {useEffect, useState} from "react";
import {usePathname} from "next/navigation";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons";
import {NavigationLink} from "~/components/navigation/Link";
import {NavigationItem} from "@/utils/content/navigation";
import {Locale} from "~/i18n-config";
import clsx from "clsx";

export function HeaderMain(
    { lang, navigation }: { lang: Locale, navigation: NavigationItem[] }
) {
    return (
        <nav className="header hidden lg:flex lg:grow-1 gap-4 pr-10">
            <HeaderMainNavigation
                lang={lang}
                navigation={navigation}
                visible={true}
                level={0} />
        </nav>
    );
}

export function HeaderMainNavigation(
    { lang, navigation, level, visible }: { lang: Locale, navigation: NavigationItem[], level: number, visible: boolean }
) {
    return (
        <ul className={clsx(level === 0 || visible ? "block gap-10" : "hidden", `nav level-${level}`)}>
            {navigation.map((item: NavigationItem) => {
                return (
                    <HeaderMainNavigationItem
                        key={`hmni-${item.id}-${level}`}
                        lang={lang}
                        item={item}
                        level={level}
                    />
                );
            })}
        </ul>
    );
}

export function HeaderMainNavigationItem(
    { lang, item, level }: { lang: Locale, item: NavigationItem, level: number }
) {
    const pathname = usePathname();
    const [showMenu, setShowMenu] = useState(false);

    useEffect(() => {
        setShowMenu(false);
    }, [pathname]);

    return (
        <li onMouseEnter={() => setShowMenu(true)} onMouseLeave={() => setShowMenu(false)}>
            <NavigationLink
                lang={lang}
                item={item}
                className="text-lg font-normal"
            />
            {item.children && item.children.length > 0 && (
                <HeaderMainNavigation
                    lang={lang}
                    navigation={item.children}
                    level={level + 1}
                    visible={showMenu}
                />
            )}
        </li>
    );
}

export function HeaderMainMobile(
    { lang, navigation }: { lang: Locale, navigation: NavigationItem[] }
) {
    return (
        <nav className="header px-6 mt-4 py-3 space-y-2">
            <HeaderMainMobileNavigation lang={lang} navigation={navigation} level={0} />
        </nav>
    );
}

export function HeaderMainMobileNavigation(
    { lang, navigation, level }: { lang: Locale, navigation: NavigationItem[], level: number }
) {
    return (
        <ul className={`nav level-${level}`}>
            {navigation.map((item: NavigationItem) => {
                return (
                    <HeaderMainMobileNavigationItem
                        key={`hmmni-mobile-${item.id}-${level}`}
                        lang={lang}
                        item={item}
                        level={level}
                    />
                );
            })}
        </ul>
    );
}

export function HeaderMainMobileNavigationItem(
    { lang, item, level }: { lang: Locale, item: NavigationItem, level: number }
) {
    return (
        <li>
            <NavigationLink
                lang={lang}
                item={item}
                append={
                    <FontAwesomeIcon
                        size="lg"
                        color="#000000"
                        icon={faArrowRight}
                        className="hidden group-hover:inline-block pl-2 relative animate-bounceRight"
                    />
                }
                className="text-lg font-normal text-zinc-800 group"
            />
            {item.children && item.children.length > 0 && (
                <HeaderMainMobileNavigation
                    lang={lang}
                    navigation={item.children}
                    level={level + 1}
                />
            )}
        </li>
    );
}
